var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canBook && _vm.coachDetail && _vm.coachDetail.userProfile.consultBookingLink)?_c('j-alert',[_vm._v("You can "),_c('a',{staticClass:"font-weight-bold",attrs:{"href":_vm.coachDetail.userProfile.consultBookingLink,"target":"_blank"}},[_vm._v("book a consult")]),_vm._v(" with Coach "+_vm._s(_vm.coachDetail.firstName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }